<template>
    <div>
        <!-- //---------------------[FILE SELECTOR] -->
        <div v-if="file_selector">
            <input 
                type="file" id="fileInput" 
                ref="myFiles" 
                @change="FILE_SELECTED()"  
                style="display: none;"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                    application/vnd.ms-excel"> 
        </div>

        <!-- //-----------------[DIALOG VIEW] -->
        <v-dialog  
            v-model="dialog_excel_selector" 
            :max-width="dialog_width?dialog_width:'500'"                     
            :persistent='true'  
            :overlay="false"
            scrollable
            >
            <v-card class="" 
                @dragover.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false"
                @drop.prevent="ON_EXCEL_DROP" 
            > 
                <v-progress-linear v-if="loading"
                    class="white ma-0 " 
                    :indeterminate="true"
                    height="5">
                </v-progress-linear>
    
                <!-- // DIALOG TITLE -->
                <v-card-title  
                    class="primary headline white--text"
                    primary-title  >  
                    <v-icon dark class="mr-2">mdi-microsoft-excel</v-icon>
                    EXCEL CONSOLE

                    <v-spacer></v-spacer> 

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on3 }">
                            <v-btn v-on="on3" 
                                class ='ma-0' 
                                dark small
                                @click="ON_CLOSE_DIALOG()"
                                icon>
                                <v-icon>close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cancel</span>
                    </v-tooltip>
                </v-card-title>


                <v-divider dark=""></v-divider> 
                <v-card-text class="ma-0 pa-0" > 
                    <v-container  > 
                        <!-- ON LOADING -->
                        <v-layout justify-center v-if="loading" class="pa-5 upload-container">
                            <v-progress-circular
                                :rotate="-90"
                                :size="100"
                                :width="15"
                                :value="loadingValue"
                                color="primary" >
                                {{ loadingValue }}
                                </v-progress-circular>
                        </v-layout>
                        <div v-else>
                            <!-- ON IN PUT -->
                            <div v-if="!files || isDragging" >
                                <v-card   height="150"  flat   
                                    class="ma-0 pa-0"
                                    @click="EXCEL_SELECT()"
                                    >
                                    <v-layout column fill-height justify-center align-center  
                                    :class="{ 'dragging': isDragging }"
                                        class=" ma-0 pa-2 upload-container"   flat="" tile="">
                                       
                                            <v-icon size="50" color="green" v-if="isDragging">mdi-file-upload</v-icon> 
                                            <v-icon size="50" color="" v-else>mdi-file-upload-outline</v-icon> 
                                            <div class="font-weight-bol not-f5 grey--text--darken-2 mt-2 mb-1">Drag and drop</div> 
                                            <!-- <div class="secondary--text font-weight-bold italic"></div> -->
                                             <v-btn color="secondary" outlined small tile>Click to Select file</v-btn>
                                              
                                    </v-layout >  
                                </v-card>
                            </div>
                            <!-- ON SHOW RESULTS -->
                            <div v-else>
                                <v-card flat :max-height="vsh-200" class="mbs-scroll-y"> 
                                    <v-list >
                                        <template v-if="WB.Props">
                                            <div class="upload-container"
                                                @click="EXCEL_SELECT()"
                                                @dragover.prevent="isDragging = true"
                                                @dragleave.prevent="isDragging = false"
                                                @drop.prevent="ON_EXCEL_DROP" > 
                                                <v-layout class="ma-0 px-2 py-3"   align-center>
                                                    <v-icon color="green" size="50" class="mr-1">mdi-microsoft-excel</v-icon>
                                                    <div>
                                                        <div class="font-weight-bold">{{ files?.[0]?.name }}</div>
                                                        <div>{{(files?.[0]?.size/1025).toFixed(1) }} KB</div>
                                                    </div> 
                                                </v-layout> 
                                            </div>
                                            <v-subheader >
                                                File Details
                                            </v-subheader> 
                                            <v-list-item  
                                                @click=""
                                                >
                                                <v-list-item-icon>
                                                    <v-icon>person</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="'Author'"/> 
                                                    <v-list-item-subtitle v-html="WB.Props.Author?WB.Props.Author:'.'"/> 
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item  
                                                @click=""
                                                >
                                                <v-list-item-icon>
                                                    <v-icon>person</v-icon>
                                                </v-list-item-icon>
        
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="'Modified by'"/> 
                                                    <v-list-item-subtitle v-html="WB.Props.LastAuthor?WB.Props.LastAuthor:'.'"/> 
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item  
                                                @click=""
                                                >
                                                <v-list-item-icon>
                                                    <v-icon>description</v-icon>
                                                </v-list-item-icon>
        
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="'File Type'"/> 
                                                    <v-list-item-subtitle v-html="WB.Props.Application?WB.Props.Application:'.'"/> 
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item  
                                                @click=""
                                                >
                                                <v-list-item-icon>
                                                    <v-icon>schedule</v-icon>
                                                </v-list-item-icon>
        
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="'Date'"/> 
                                                    <v-list-item-subtitle v-html="WB.Props.ModifiedDate?WB.Props.ModifiedDate:'.'"/> 
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>  
                                        <template v-if="WB.SheetNames">
                                            <v-subheader >
                                                Attached Data Sheets
                                            </v-subheader> 
                                            <v-alert class="ma-0 ml-4" outlined
                                                dense text type="error"
                                                v-if="WB.SheetNames.indexOf(preferred_data_sheet?.value) == -1"
                                                >
                                                <div>
                                                    <strong>{{preferred_data_sheet?.name}}</strong> is required
                                                    <div>
                                                        <small>Select sheet containing  {{preferred_data_sheet?.name}} data.</small>
                                                    </div>
                                                </div>
                                            </v-alert>
                                            <v-list-item v-for="(item, index) in WB.SheetNames" :key="index" 
                                                @click="SELECT_SHEET(item,index)" >
                                                <v-list-item-icon>
                                                    <v-btn icon>
                                                        <v-icon v-if="selected_sheets[item]">mdi-checkbox-outline</v-icon>
                                                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                                                    </v-btn>
                                                </v-list-item-icon> 
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="'Sheet '+(index+1)"/> 
                                                    <v-list-item-subtitle v-html="item"/> 
                                                </v-list-item-content>
                                            </v-list-item> 
                                        </template>
                                    </v-list>
                                </v-card>
    
                                <v-divider class="mb-1"/> 
                                <v-card-actions  >
                                    <v-spacer></v-spacer>
                                    <v-btn  
                                        @click="ON_CLOSE_RESULTS"
                                        color="primary" 
                                        text="">Cancel</v-btn>
                                    <v-btn  tile class="px-9"
                                        @click="ON_SELECT_DATA"
                                        color="primary" dark=""
                                        >Upload Selected</v-btn>
                                </v-card-actions> 
                            </div> 
                        </div> 
                    </v-container>  
                </v-card-text> 
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import XLSX from "xlsx" 
    let PAGE_NAME = "EXCEL-SELECTOR"
    export default {
        props:['notShow','dialog_show'],
        data(){
            return{
                show:false,
                show_input:false,
                show_output:false,
                preferred_data_sheet:null,
                dialog_width:null,
                dialog_excel_selector:false,
                isDragging: false,
                file_selector:false,
                loading:false,
                loadingValue:10,
                files: null,  
                WB:null,
                json_sheets:null,
                process_payload:null,
                selected_sheets:{}
            } 
        },  
        created() {
            try {
                this.MBS.events.$on('ON_EXCEL_SELECT', this.ON_EXCEL_SELECT);   
                this.MBS.events.$on('ON_EXCEL_INPUT', this.ON_EXCEL_INPUT);   
                this.MBS.events.$on('ON_EXCEL_DROP', this.ON_EXCEL_DROP);   
                this.INITIATE_SELECTOR()
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){
            try {
                this.files=null 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
        },
        computed:{
            user(){
                return  this.$store.getters.getUser
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
        },
        methods:{ 
            INITIATE_SELECTOR(){
                this.dialog_excel_selector = false   
                if (this.files) {
                    if(this.show_output){
                        this.dialog_excel_selector = true
                    }
                }else{
                    if(this.show_input){
                        this.dialog_excel_selector = true
                    }
                }
                this.$emit('on_initiate') 
            }, 
            ON_CLOSE_DIALOG(){
                this.$emit('on_close_dialog') 
                this.dialog_excel_selector = false 
            }, 
            ON_CLOSE_RESULTS(){
                this.$emit('notNo')
                this.files = null 
            },  
            async ON_SELECT_DATA(){
                const wb = this.WB
                const selected_sheets = this.selected_sheets
                const json_sheets = this.json_sheets 
                if (!this.MBS.actions.SIZE(selected_sheets)) {
                    this.MBS.actions.dialog({
                        show:true,
                        icon:"mdi-microsoft-excel",
                        title:"SELECT DATA SHEET",
                        text:"You must at least select one excel sheet to import data from.",
                        btnYes:"SELECT SHEET"
                    })
                    return
                }
                const sheet_data_res = await this.CALCULATE_SHEET_DATA({ 
                    json_sheets,
                    sheets_names:selected_sheets
                })
                const sheet_data = sheet_data_res.data 
                this.ON_CLOSE_RESULTS()
                const process_payload = this.process_payload?this.process_payload:{}
                console.log(sheet_data_res,'...sheet_data_res++++');
                console.log(process_payload,'...process_payload');
                
                console.log({...process_payload,
                    wb,selected_sheets,
                    json_sheets,sheet_data},"***********-------------");
                
                this.MBS.events.$emit('ON_EXCEL_DATA_SELECTED',{
                    ...process_payload,
                    wb,selected_sheets,
                    json_sheets,sheet_data
                })  
            },
            RESET_ALL_DATA(){ 
                let response ={
                    from:'RESET_ALL_DATA',
                    page:PAGE_NAME, 
                }
                return new Promise( async(resolve,reject)=>{
                    try { 
                        // let pricing_tier = this.pricing_tier
                        // let auto_print = this.auto_print
                        // let waiter_uid = this.waiter_uid
                        setTimeout( async () => { 
                            Object.assign(this.$data, this.$options.data())  
                            
                            //restore data
                            // this.pricing_tier = pricing_tier
                            // this.auto_print = auto_print
                            // this.waiter_uid = waiter_uid
                            resolve({success:true})
                        }, 50);
                    } catch (error) {
                        response = {...response,error:error}
                        this.MBS.actions.error(response) 
                        reject(response)
                    } 
                })
            },
            async ON_EXCEL_SELECT(payload){
                try { 
                    console.log(payload,'payload..............');
                    
                    await this.RESET_ALL_DATA() 
                    this.show_input = payload?.show_input
                    this.show_output = payload?.show_output
                    this.process_payload = payload
                    this.preferred_data_sheet = payload?.preferred_data_sheet
                    this.INITIATE_SELECTOR()
                    this.file_selector = true
                
                    if (!this.show_input) {
                        this.EXCEL_SELECT()
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EXCEL_SELECT',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            EXCEL_SELECT(){
                try { 
                    setTimeout(() => {
                        console.log( this.$refs,' this.$refs.....');
                        
                        this.$refs.myFiles?.click()  
                    }, 10);  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EXCEL_SELECT',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            ON_EXCEL_INPUT(){
                try { 
                    this.dialog_excel_selector = true
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EXCEL_INPUT',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            async FILE_SELECTED(){
                try {
                    this.$emit("onLoadingFile",null)
                    let files = this.$refs.myFiles.files
                    this.files = files
                    this.loading = true
                    this.loadingValue = 10 
                    
                    if (files.length==0) {
                        this.files = null
                        setTimeout(() => {
                            this.loadingValue = 100 
                        }, 500);
                        setTimeout(() => { 
                            this.MBS.actions.snackbar({
                                show:true,
                                time:10000,
                                text:'Not Selected',
                                color:'primary'
                            })
                            this.loading = false 
                            this.$emit("onNoFileSelected",null)
                        }, 1000); 
                    }else{
                        this.PROCESS_SELECTED_FILE(files[0]) 
                    }   
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FILE_SELECTED',
                        page:PAGE_NAME, 
                    }) 
                    this.$emit("onError",error)
                }
            }, 
            async ON_EXCEL_DROP(payload) {
                try {
                    console.log(payload,'payload/......');
                    const e = payload?.e
                    if (!e) {
                        console.log(e,'e..........');
                        return
                    }
                    
                    const files = e.dataTransfer.files;
                    await this.RESET_ALL_DATA() 
                    this.files = files
                    this.show_input = payload?.show_input
                    this.show_output = payload?.show_output
                    this.process_payload = payload

                    console.log(files,'files.........');
                    
     
                    if (files.length > 0) {
                        const file = files[0];  
                        if (this.isValidFileType(file)) {
                            this.PROCESS_SELECTED_FILE(file);
                        } else {
                            console.error("Invalid file type"); 
                        }
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EXCEL_DROP',
                        page:PAGE_NAME, 
                    }) 
                    this.$emit("onError",error)
                }
            },
            async PROCESS_SELECTED_FILE(file){
                try {
                    this.file_selector = false
                    this.$emit("onProcessingFile",null) 
                    this.loading = true
                    this.loadingValue = 20  

                    const reader = new FileReader()
                    reader.readAsArrayBuffer(file) 
                    reader.onload = async ()=>{
                        try {
                            this.loadingValue = 100
                            setTimeout(() => { 
                                this.loading = false 
                            }, 1000); 
                            let data = new Uint8Array(reader.result)
                            let wb = XLSX.read(data,{type:"array"})
                            const res = await this.CALCULATE_JSON(wb) 
                            console.log(wb,'wb......');
                            console.log(res,'res......');
                            
                            this.WB = wb
                            this.json_sheets = res?.data
                            // this.INITIATE_SELECTOR()
                            // this.file_selector = true
                             this.EXCEL_SELECT()
                            this.$emit("onFileSelected",wb,file,res)   
                            this.MBS.events.$emit("ON_EXCEL_FILE_SELECTED",wb,file,res)   
                            
                        } catch (error) {
                            this.MBS.actions.error({
                                error:error,
                                from:'PROCESS_SELECTED_FILE',
                                page:PAGE_NAME, 
                            }) 
                            this.$emit("onError",error)
                        }
                    }  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'PROCESS_SELECTED_FILE',
                        page:PAGE_NAME, 
                    }) 
                    this.$emit("onError",error)
                }
            }, 
            
            isValidFileType(file) {
                const validTypes = [
                    'text/csv',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                    'application/vnd.ms-excel' // .xls
                ];
                // Also check extension as backup
                const validExtensions = ['.csv', '.xlsx', '.xls'];
                
                return validTypes.includes(file.type) || 
                        validExtensions.some(ext => file.name.toLowerCase().endsWith(ext));
            },
            cleanArrayData(dataArray){
                return dataArray.map(obj => {
                    const newObj = {};
                    
                    for (let key in obj) {
                    // 1. Convert to Lowercase
                    // 2. Replace spaces with underscores
                    // 3. Trim any extra whitespace
                    const cleanKey = key.toLowerCase().trim().replace(/\s+/g, '_');
                    
                    newObj[cleanKey] = obj[key];
                    }
                    
                    return newObj;
                });
            },
            CALCULATE_JSON(wb){
                return new Promise((resolve,reject)=>{
                    let response = {
                        from:'CALCULATE_JSON',
                        page:PAGE_NAME, 
                        payload:wb
                    }
                    try { 
                        let sheets = wb?wb.SheetNames:null
                        if(!sheets){
                            resolve({
                                success:false,
                                data:null
                            })
                        }
                        let json_sheets = []
                        sheets.forEach(element => {
                            let worksheet_item = wb.Sheets[element]
                            if (worksheet_item) {
                                let json_item = this.XLSX.utils.sheet_to_json(worksheet_item) 
                                if (json_item) {
                                    json_sheets.push({
                                        name:element,
                                        json:json_item
                                    })
                                }
                            } 
                        }); 
                        resolve({
                            success:true,
                            data:json_sheets
                        })
                    } catch (error) {
                        reject({
                            success:false,
                            error:error,
                            ...response
                        })
                    } 
                })
            }, 
            SELECT_SHEET(name){
                try {
                    const name_value = this.selected_sheets[name]?false:true
                    this.$set(this.selected_sheets,name,name_value) 
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SELECT_SHEET',
                        page:PAGE_NAME, 
                    })  
                }
            }, 
            CALCULATE_SHEET_DATA(payload){
                return new Promise((resolve,reject)=>{
                    let response = {
                        from:'CALCULATE_SHEET_DATA',
                        page:PAGE_NAME, 
                        payload:payload
                    }
                    try { 
                        const {json_sheets,sheets_names} = payload|| {};
                        let selected_sheets_json = []
                        let selected_sheets = {}
                        let mix = []
                        if (sheets_names) {
                            for (const name in sheets_names) { 
                                const sheet_name = sheets_names[name];
                                if (sheet_name) {
                                    const sheet = json_sheets.find(sh=>sh.name==name)
                                    const Json = sheet?.json
                                    const json = Json?this.cleanArrayData(Json):null

                                    selected_sheets_json.push({...sheet,json}) 
                                    selected_sheets[name]=json
                                    mix.push(...json) 
                                }  
                            }
                        } 
                        
                        resolve({
                            success:true,
                            data:{
                                sheet:selected_sheets,
                                json:selected_sheets_json,
                                mix
                            },
                        })
                         
                    } catch (error) {
                        reject({
                            success:false,
                            error:error,
                            ...response
                        })
                    } 
                })
            }, 

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_EXCEL_SELECT', this.ON_EXCEL_SELECT);   
                this.MBS.events.$off('ON_EXCEL_INPUT', this.ON_EXCEL_INPUT);   
                this.MBS.events.$off('ON_EXCEL_DROP', this.ON_EXCEL_DROP);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{
            user(value){  
            },
            files(value){
                this.INITIATE_SELECTOR()
            }
            
        } 
    }
</script>
